import React from "react";
import {
  FormControl,
  InputLabel,
  ListSubheader,
  Select as MuiSelect,
  MenuItem,
  FormHelperText,
} from "@material-ui/core";

const data = [
  {
    id: 1,
    name: "product1",
    plans: [
      { id: 1, name: "plan1", type: "ltd", price: "10.00" },
      { id: 2, name: "plan2", type: "subscription", price: "10.00" },
    ],
  },
  {
    id: 2,
    name: "product2",
    plans: [
      { id: 3, name: "plan3", type: "ltd", price: "10.00" },
      { id: 4, name: "plan4", type: "subscription", price: "10.00" },
    ],
  },
];
export default function GroupedSelect(props) {
  const { name, label, value, error = null, onChange, options } = props;
  const [products, setProducts] = React.useState();
  const [selectedPlan, setSelectedPlan] = React.useState({});

  React.useEffect(() => {
    setProducts(data);
  }, []);
  const renderSelectGroup = (product) => {
    const items = product.plans.map((p) => {
      return (
        <MenuItem key={p.id} value={p.id}>
          {p.id} {p.name} {p.type} {p.price}
        </MenuItem>
      );
    });
    return [<ListSubheader>{product.name}</ListSubheader>, items];
  };
  return (
    <FormControl variant="outlined" {...(error && { error: true })}>
      <InputLabel>{label}</InputLabel>
      <MuiSelect label={label} name={name} value={value} onChange={onChange}>
        <MenuItem value="">None</MenuItem>
        {products && products.map((item) => renderSelectGroup(item))}
      </MuiSelect>
      {error && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  );
}

// export default function GroupedSelect(props) {
//   const { name, label, value, error = null, onChange, options } = props;
//   const renderSelectGroup = (district) => {
//     const items = district.children.map((p) => {
//       console.log("district", district, p);
//       return (
//         <MenuItem key={p.value} value={p}>
//           {p.lable}
//         </MenuItem>
//       );
//     });
//     return [<ListSubheader>{district.lable}</ListSubheader>, items];
//   };
//   return (
//     <FormControl variant="outlined" {...(error && { error: true })}>
//       <InputLabel>{label}</InputLabel>
//       <MuiSelect label={label} name={name} value={value} onChange={onChange}>
//         <MenuItem value="">None</MenuItem>
//         {options && options.map((item) => renderSelectGroup(item))}
//       </MuiSelect>
//       {error && <FormHelperText>{error}</FormHelperText>}
//     </FormControl>
//   );
// }

// import * as React from "react";
// import {
//   FormControl,
//   ListSubheader,
//   InputLabel,
//   Select,
//   MenuItem,
//   FormHelperText,
// } from "@material-ui/core";

// export default function GroupedSelect() {
//   return (
//     <div>
//       <FormControl sx={{ m: 1, minWidth: 120 }}>
//         <InputLabel htmlFor="grouped-native-select">Grouping</InputLabel>
//         <Select
//           native
//           defaultValue=""
//           id="grouped-native-select"
//           label="Grouping"
//         >
//           <option aria-label="None" value="" />
//           <optgroup label="Category 1">
//             <option value={1}>Option 1</option>
//             <option value={2}>Option 2</option>
//           </optgroup>
//           <optgroup label="Category 2">
//             <option value={3}>Option 3</option>
//             <option value={4}>Option 4</option>
//           </optgroup>
//         </Select>
//       </FormControl>
//       <FormControl sx={{ m: 1, minWidth: 120 }}>
//         <InputLabel htmlFor="grouped-select">Grouping</InputLabel>
//         <Select defaultValue="" id="grouped-select" label="Grouping">
//           <MenuItem value="">
//             <em>None</em>
//           </MenuItem>
//           <ListSubheader>Category 1</ListSubheader>
//           <MenuItem value={1}>Option 1</MenuItem>
//           <MenuItem value={2}>Option 2</MenuItem>
//           <ListSubheader>Category 2</ListSubheader>
//           <MenuItem value={3}>Option 3</MenuItem>
//           <MenuItem value={4}>Option 4</MenuItem>
//         </Select>
//       </FormControl>
//     </div>
//   );
// }
